<div class="auth-container">
  <div class="auth-card">
    <!-- Logo Header -->
    <div class="auth-header">
      <img src="assets/branding/logo.png" alt="" class="auth-logo">
      <h1>Riya Shuma</h1>
      <p class="tagline">Smart Fleet</p>
    </div>

    <!-- Tabs -->
    <div class="auth-tabs">
      <button class="tab" [class.active]="!isRegisterMode" (click)="isRegisterMode = false">
        Login
      </button>
      <button class="tab" [class.active]="isRegisterMode" (click)="isRegisterMode = true">
        Register
      </button>
    </div>

    <!-- Login Form -->
    <form *ngIf="!isRegisterMode" [formGroup]="loginForm" (ngSubmit)="onLogin()" class="auth-form">
      <div class="form-group">
        <label for="loginEmail">Email Address</label>
        <div class="input-with-icon">
          <i class="material-icons">email</i>
          <input type="email" id="loginEmail" formControlName="email" 
                 class="form-control" placeholder="you@example.com">
        </div>
      </div>

      <div class="form-group">
        <label for="loginPassword">Password</label>
        <div class="input-with-icon">
          <i class="material-icons">lock</i>
          <input type="password" id="loginPassword" formControlName="password" 
                 class="form-control" placeholder="••••••••">
        </div>
      </div>

      <div class="form-options">
        <div class="remember-me">
          <input type="checkbox" id="remember" formControlName="rememberMe">
          <label for="remember">Remember me</label>
        </div>
        <a href="#" class="forgot-password">Forgot password?</a>
      </div>

      <button type="submit" class="btn btn-primary btn-block" [disabled]="loginForm.invalid || isLoading">
        <span *ngIf="!isLoading">Sign In</span>
        <span *ngIf="isLoading">Signing In...</span>
      </button>

      <div class="auth-divider">
        <span>OR</span>
      </div>

      <p class="auth-switch">
        Don't have an account? 
        <a href="#" (click)="isRegisterMode = true; $event.preventDefault()">
          Register here
        </a>
      </p>
    </form>

    <!-- Register Form -->
    <form *ngIf="isRegisterMode" [formGroup]="registerForm" (ngSubmit)="onRegister()" class="auth-form">
      <div class="form-group">
        <label for="registerRole">Account Type</label>
        <select id="registerRole" formControlName="userRole" class="form-control" (change)="resetPassengerOnboarding()">
          <option value="passenger">Passenger</option>
          <option value="operator">Transport Operator</option>
        </select>
      </div>

      <ng-container *ngIf="registerForm.get('userRole')?.value === 'passenger'; else operatorRegistration">
        <div class="passenger-onboarding" [formGroup]="passengerOnboardingForm">
          <div class="form-group" *ngIf="passengerOnboardingStep === 'contact'">
            <label for="passengerContact">Cellphone number or email</label>
            <div class="input-with-icon">
              <i class="material-icons">person_search</i>
              <input type="text" id="passengerContact" formControlName="contact"
                     class="form-control" placeholder="+27 61 545 5921 or you@example.com">
            </div>
            <p class="helper-text">We will check existing passenger accounts and synced commuter profiles before asking for more details.</p>
          </div>

          <div class="onboarding-panel" *ngIf="passengerOnboardingStep === 'confirm'">
            <p class="eyebrow">Details found</p>
            <h3>{{ getPrefillName() || 'Passenger details' }}</h3>
            <dl>
              <div>
                <dt>Name</dt>
                <dd>{{ getPrefillName() || '-' }}</dd>
              </div>
              <div>
                <dt>Phone</dt>
                <dd>{{ getPrefillPhone() || getContactPhoneFallback() || '-' }}</dd>
              </div>
              <div>
                <dt>Email</dt>
                <dd>{{ getPrefillEmail() || getContactEmailFallback() || 'Email needed' }}</dd>
              </div>
            </dl>
            <p class="helper-text" *ngIf="passengerLookupResult?.canPrefill">Confirm these details to continue onboarding.</p>
            <p class="helper-text" *ngIf="!passengerLookupResult?.canPrefill">We can continue with your contact details and collect what is still needed.</p>
          </div>

          <div class="onboarding-panel" *ngIf="passengerOnboardingStep === 'existingUser'">
            <p class="eyebrow">Account found</p>
            <h3>You already have a passenger account</h3>
            <p>Use the sign-in screen to continue. If your email still needs verification, request a new verification email from your account flow.</p>
            <dl>
              <div>
                <dt>Account</dt>
                <dd>{{ getExistingUserEmail() || passengerOnboardingForm.get('contact')?.value }}</dd>
              </div>
            </dl>
          </div>

          <div class="onboarding-panel" *ngIf="passengerOnboardingStep === 'notFound'">
            <p class="eyebrow">No match found</p>
            <h3>We could not find existing passenger details</h3>
            <p>Continue with manual passenger registration using the standard form fields.</p>
            <dl>
              <div>
                <dt>Contact searched</dt>
                <dd>{{ passengerOnboardingForm.get('contact')?.value || '-' }}</dd>
              </div>
            </dl>
          </div>

          <div class="onboarding-panel manual-registration-panel" *ngIf="passengerOnboardingStep === 'manualRegistration'" [formGroup]="registerForm">
            <p class="eyebrow">Manual registration</p>
            <h3>Create your passenger account</h3>
            <div class="form-group">
              <label for="manualPassengerName">Full Name</label>
              <div class="input-with-icon">
                <i class="material-icons">person</i>
                <input type="text" id="manualPassengerName" formControlName="userName"
                       class="form-control" placeholder="John Doe">
              </div>
              <small class="field-error" *ngIf="registerForm.get('userName')?.touched && registerForm.get('userName')?.invalid">
                Full name is required.
              </small>
            </div>

            <div class="form-group">
              <label for="manualRegisterEmail">Email Address</label>
              <div class="input-with-icon">
                <i class="material-icons">email</i>
                <input type="email" id="manualRegisterEmail" formControlName="userEmail"
                       class="form-control" placeholder="you@example.com">
              </div>
              <small class="field-error" *ngIf="registerForm.get('userEmail')?.touched && registerForm.get('userEmail')?.invalid">
                A valid email address is required.
              </small>
            </div>

            <div class="form-group">
              <label for="manualPassengerPhone">Cellphone number</label>
              <div class="input-with-icon">
                <i class="material-icons">phone</i>
                <input type="tel" id="manualPassengerPhone" formControlName="phoneNumber"
                       class="form-control" placeholder="061 545 5921">
              </div>
            </div>

            <div class="form-group">
              <label for="manualPassengerPassword">Password</label>
              <div class="input-with-icon">
                <i class="material-icons">lock</i>
                <input type="password" id="manualPassengerPassword" formControlName="userPassword"
                       class="form-control" placeholder="Create a password">
              </div>
              <small class="field-error" *ngIf="registerForm.get('userPassword')?.touched && registerForm.get('userPassword')?.invalid">
                Password must be at least 6 characters.
              </small>
            </div>

            <div class="form-group terms">
              <input type="checkbox" id="manualPassengerTerms" formControlName="acceptTerms">
              <label for="manualPassengerTerms">
                I agree to the
                <a href="#">Terms of Service</a> and
                <a href="#">Privacy Policy</a>
              </label>
            </div>
            <small class="field-error" *ngIf="registerForm.get('acceptTerms')?.touched && registerForm.get('acceptTerms')?.invalid">
              You must accept the terms before creating an account.
            </small>
          </div>

          <div class="form-group" *ngIf="passengerOnboardingStep === 'manualEmail'">
            <label for="manualPassengerEmail">Email address</label>
            <div class="input-with-icon">
              <i class="material-icons">email</i>
              <input type="email" id="manualPassengerEmail" formControlName="manualEmail"
                     class="form-control" placeholder="you@example.com">
            </div>
            <small class="field-error" *ngIf="passengerOnboardingForm.get('manualEmail')?.touched && passengerOnboardingForm.get('manualEmail')?.invalid">
              A valid email address is required.
            </small>
            <p class="helper-text">We need an email address so we can send your verification link.</p>
          </div>

          <div class="onboarding-panel" *ngIf="passengerOnboardingStep === 'queued'">
            <p class="eyebrow">Next step</p>
            <h3>Check your inbox</h3>
            <p>Your verification email has been queued. Follow the link in that email to finish setting up your passenger account.</p>
            <dl>
              <div>
                <dt>Delivery reference</dt>
                <dd>{{ passengerStartResult?.notificationDeliveryID || '-' }}</dd>
              </div>
            </dl>
          </div>

          <div class="onboarding-panel" *ngIf="passengerOnboardingStep === 'verificationIssue'">
            <p class="eyebrow">Verification pending</p>
            <h3>Email verification was not queued</h3>
            <p>We have your email address, but the verification email was not queued. Please try again, or contact support if it keeps happening.</p>
            <dl>
              <div>
                <dt>Email</dt>
                <dd>{{ passengerOnboardingForm.get('manualEmail')?.value || getPrefillEmail() || '-' }}</dd>
              </div>
            </dl>
          </div>

          <div class="form-group terms" *ngIf="passengerOnboardingStep !== 'existingUser' && passengerOnboardingStep !== 'queued' && passengerOnboardingStep !== 'notFound' && passengerOnboardingStep !== 'manualRegistration' && passengerOnboardingStep !== 'verificationIssue'">
            <input type="checkbox" id="passengerTerms" formControlName="acceptTerms">
            <label for="passengerTerms">
              I agree to the
              <a href="#">Terms of Service</a> and
              <a href="#">Privacy Policy</a>
            </label>
          </div>
          <small class="field-error" *ngIf="passengerOnboardingForm.get('acceptTerms')?.touched && passengerOnboardingForm.get('acceptTerms')?.invalid">
            You must accept the terms before continuing.
          </small>

          <button *ngIf="passengerOnboardingStep === 'contact'" type="button" class="btn btn-primary btn-block"
                  [disabled]="isLoading" (click)="lookupPassengerContact()">
            <span *ngIf="!isLoading">Continue</span>
            <span *ngIf="isLoading">Checking...</span>
          </button>

          <button *ngIf="passengerOnboardingStep === 'confirm' || passengerOnboardingStep === 'manualEmail'" type="button"
                  class="btn btn-primary btn-block" [disabled]="isLoading" (click)="startPassengerOnboarding()">
            <span *ngIf="!isLoading">Confirm and send verification</span>
            <span *ngIf="isLoading">Starting...</span>
          </button>

          <button *ngIf="passengerOnboardingStep === 'existingUser'" type="button" class="btn btn-primary btn-block" (click)="useExistingUserLogin()">
            Go to sign in
          </button>

          <button *ngIf="passengerOnboardingStep === 'notFound'" type="button" class="btn btn-primary btn-block" (click)="continueManualPassengerRegistration()">
            Continue manually
          </button>

          <button *ngIf="passengerOnboardingStep === 'manualRegistration'" type="button" class="btn btn-primary btn-block"
                  [disabled]="isLoading" (click)="submitManualPassengerRegistration()">
            <span *ngIf="!isLoading">Create passenger account</span>
            <span *ngIf="isLoading">Creating...</span>
          </button>

          <button *ngIf="passengerOnboardingStep === 'verificationIssue'" type="button" class="btn btn-primary btn-block" [disabled]="isLoading" (click)="startPassengerOnboarding()">
            Try sending verification again
          </button>

          <button *ngIf="passengerOnboardingStep !== 'contact' && passengerOnboardingStep !== 'queued'" type="button" class="btn btn-secondary btn-block" (click)="resetPassengerOnboarding()">
            Use different contact
          </button>
        </div>
      </ng-container>

      <ng-template #operatorRegistration>
      <div class="form-group">
        <label for="registerName">Full Name</label>
        <div class="input-with-icon">
          <i class="material-icons">person</i>
          <input type="text" id="registerName" formControlName="userName" 
                 class="form-control" placeholder="John Doe">
        </div>
        <small class="field-error" *ngIf="registerForm.get('userName')?.touched && registerForm.get('userName')?.invalid">
          Full name is required.
        </small>
      </div>

      <div class="form-group">
        <label for="registerEmail">Email Address</label>
        <div class="input-with-icon">
          <i class="material-icons">email</i>
          <input type="email" id="registerEmail" formControlName="userEmail" 
                 class="form-control" placeholder="you@example.com">
        </div>
        <small class="field-error" *ngIf="registerForm.get('userEmail')?.touched && registerForm.get('userEmail')?.invalid">
          A valid email address is required.
        </small>
      </div>

      <div class="form-group">
        <label for="registerPhone">Cellphone Number</label>
        <div class="input-with-icon">
          <i class="material-icons">phone_iphone</i>
          <input type="tel" id="registerPhone" formControlName="phoneNumber"
                 class="form-control" placeholder="+27 82 123 4567">
        </div>
      </div>

      <div class="form-group">
        <label for="registerPassword">Password</label>
        <div class="input-with-icon">
          <i class="material-icons">lock</i>
          <input type="password" id="registerPassword" formControlName="userPassword" 
                 class="form-control" placeholder="••••••••">
        </div>
        <small class="field-error" *ngIf="registerForm.get('userPassword')?.touched && registerForm.get('userPassword')?.invalid">
          Password must be at least 6 characters.
        </small>
      </div>

      <!-- Organisation Fields (for operators) -->
      <div *ngIf="registerForm.get('userRole')?.value === 'operator'" 
           class="organisation-fields">
        <h3>Organisation Details</h3>
        
        <div class="form-group">
          <label for="organisationName">Organisation Name *</label>
          <input type="text" id="organisationName" formControlName="organisationName" 
                 class="form-control" placeholder="ABC Transport Ltd">
          <small class="field-error" *ngIf="registerForm.get('organisationName')?.touched && registerForm.get('organisationName')?.invalid">
            Organisation name is required for operators.
          </small>
        </div>

        <p class="pending-note">
          Operator accounts are created as Pending while Riya Shuma validates the business and completes onboarding.
        </p>

        <div class="form-row">
          <div class="form-group">
            <label for="organisationPhone">Phone</label>
            <input type="tel" id="organisationPhone" formControlName="organisationPhone"
                   class="form-control" placeholder="+27 12 345 6789">
          </div>

          <div class="form-group">
            <label for="organisationWebsite">Company Website</label>
            <input type="url" id="organisationWebsite" formControlName="organisationWebsite"
                   class="form-control" placeholder="www.abctransport.co.za">
            <small class="field-error" *ngIf="registerForm.get('organisationWebsite')?.touched && registerForm.get('organisationWebsite')?.invalid">
              Enter a valid company website or leave it blank.
            </small>
          </div>
        </div>

        <div class="form-group">
          <label for="organisationAddress">Address</label>
          <textarea id="organisationAddress" formControlName="organisationAddress" 
                    class="form-control" rows="2" placeholder="123 Main Street, City"></textarea>
        </div>
      </div>

      <div class="form-group terms">
        <input type="checkbox" id="terms" formControlName="acceptTerms">
        <label for="terms">
          I agree to the 
          <a href="#">Terms of Service</a> and 
          <a href="#">Privacy Policy</a>
        </label>
      </div>
      <small class="field-error" *ngIf="registerForm.get('acceptTerms')?.touched && registerForm.get('acceptTerms')?.invalid">
        You must accept the terms before creating an account.
      </small>

      <button type="submit" class="btn btn-primary btn-block" 
              [disabled]="isLoading">
        <span *ngIf="!isLoading">Create Account</span>
        <span *ngIf="isLoading">Creating Account...</span>
      </button>
      </ng-template>

      <div class="auth-divider">
        <span>OR</span>
      </div>

      <p class="auth-switch">
        Already have an account? 
        <a href="#" (click)="isRegisterMode = false; $event.preventDefault()">
          Login here
        </a>
      </p>
    </form>

    <!-- Error/Success Messages -->
    <div *ngIf="errorMessage" class="alert alert-error">
      <i class="material-icons">error</i>
      {{ errorMessage }}
    </div>

    <div *ngIf="successMessage" class="alert alert-success">
      <i class="material-icons">check_circle</i>
      {{ successMessage }}
    </div>
  </div>
</div>
